import { NetworkService } from "@/services/NetworkService"
import endpoints from "@/infrastructure/http/endpoints"
import { IUserSubscriptionHistoryRemoteDataSource } from "../../interfaces/remote/IUserSubscriptionHistoryRemoteDataSource"
import { SubscriptionHistoryResponseDTO } from "@/infrastructure/dto/SubscriptionHistoryResponseDTO"

export class UserSubscriptionHistoryRemoteDataSource implements IUserSubscriptionHistoryRemoteDataSource {
    network
    constructor(ntw: NetworkService) {
        this.network = ntw
    }

    list(userId: string): Promise<SubscriptionHistoryResponseDTO> {
        return this.network.get(`${endpoints.userSubscriptionHistory}/${userId}`)
    }
}
